<template>
  <div class="">
    <m-category-wrapper @categories="dataReady">
      <template v-slot="{ categories,imageHandler ,setLinkType}">
        <div class="row">
          <template v-for="category in categoryItems" :key="category.id">
            <div :class="categoryItemClass">
              <m-a :href="setLinkType(category,linkType)">
                <m-category-card900 :category="category"/>
              </m-a>
            </div>
          </template>
        </div>
      </template>
    </m-category-wrapper>
  </div>
</template>

<script>
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import mA from '../../Tags/A'
import mCategoryCard900 from "../../Category/Card/CategoryCard900";

export default {
  name: "Categories311",
  components: {mCategoryWrapper, mA, mCategoryCard900},
  props: {
    categoryItemClass: {
      default: 'col-lg-4'
    },
    linkType: {
      options: ['blog', 'SingleCategory', 'Products'],
      default: 'SingleCategory'
    },
    excludeCategoryItem: {
      default: null,
      type: Object,
    }
  },
  data() {
    return {
      categoryItems: []
    }
  },
  methods: {
    dataReady(data) {

      data = data.data.data

      if (this.excludeCategoryItem != null) {
        let categoryKeys = Object.values(this.excludeCategoryItem)
        this.categoryItems = data.filter(item => {
          return categoryKeys.indexOf(item.id.toString()) === -1
        })
        return true
      }

      this.categoryItems = data

    }
  }
}
</script>

<style scoped>

</style>